<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";
import { configStore } from "@common/configStore";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import headerImage from '@components/vms/assets/Samaritan-header-mobile.png';
import { controlStore, createStoreIndex } from "@common/control/controlStore";
import { vmsIcons } from "@common/icon/iconRegistry";
import { ddStore } from "@common/ddStore";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {};

let vmsCfg = {
    cId: "vms",
    cType: "vms",
    cTitle: "VMS",
    cTemplate: `<div v-if="!ddLoading" oncontextmenu="return false" class="main-grid-wrapper">
                    <div class="main-grid-appbar">
                        <ejs-appbar cssClass="header">
                            <img :src="headerImage" alt="Samaritan" class="header-image" />
                            <div class="e-appbar-spacer"></div>
                            <control name="HELP_MENU" :items="helpMenu"></control>
                            <control name="USER_MENU" :items="userMenu" :label="userStore.coordinator.CLIENT_USER_NAME"></control>
                        </ejs-appbar>
                    </div>
                    <div class="main-grid-main-content-wrapper">
                        <div class="nav-new-left">
                            <div class="nav-new-icons">
                                <div v-if="!leftPanelOpened">
                                    <control name="EXPAND"></control>
                                </div>
                                <div v-for="(control, index) in leftMenu" :key="index" class="nav-new-icon-btn" :class="{'active': control.name === 'COORD_' + entity?.toUpperCase?.()}">
                                    <control :name="control.name"></control>
                                </div>
                            </div>
                        </div>
                        <div class="main-grid-content" v-if="!reloading">
                            <vms-main-grid
                                v-if="psp && psp !== 'dashboard'"
                                :c-id="'vmsMainGrid__' + entity"
                                :prop-psp="psp"
                                :prop-left-panel-opened="leftPanelOpened"
                                @update:prop-left-panel-opened="leftPanelOpened = $event"
                                ref="vmsMainGrid"
                            ></vms-main-grid>
                            <layout-container v-if="psp === 'dashboard'" :c-id="accountSettings.ACCOUNT_EC_DASHBOARD_ID"></layout-container>
                        </div>
                        <div class="main-grid-right-sidebar"></div>
                    </div>
                </div>
                `,
    controls: [
        {
            name: 'HELP_MENU',
            type: 'dropdownbutton',
            iconCss: 'fa-regular fa-circle-question',
            cssClass: 'e-caret-hide',
            width: '28px',
            onselect: 'doAction'
        },
        {
            name: 'USER_MENU',
            type: 'dropdownbutton',
            iconCss: 'fa-regular fa-user',
            width: 'fit-content',
            onbeforeitemrender: 'onBeforeItemRender',
            onselect: 'doAction'
        }
    ]
};

const vmsCmp = {
    name: 'vms',
    preInitControls: true,
    editorSettings: editorSettings,
    props: {
        entity: {
            default: false
        },
        entityId: {
            default: false
        }
    },
    data() {
        return {
            leftMenu: [],
            userMenu: [],
            helpMenu: [],
            headerImage: headerImage,
            leftPanelOpened: true,
            selectedTab: false,
            reloading: false,
            ddLoading: true
        };
    },
    computed: {
        psp() {
            return library.getPspByAbbrev(this.entity);
        }
    },
    methods: {
        processTab(ev, button) {
            if (button?.name?.indexOf('COORD_') === -1) return;
            let tmpPspAbbrev = button?.name?.replace('COORD_', '');
            if (!tmpPspAbbrev) return;
            let goTo = '/' + tmpPspAbbrev.toLowerCase();
            if (this.$router.currentRoute.value.path === goTo) {
                this.toggleLeftButtonPanel();
                return;
            }
            this.reloading = true;
            this.$nextTick(() => {
                this.$router.push({ path: '/' + tmpPspAbbrev.toLowerCase() });
                setTimeout(() => { this.reloading = false; }, 500);
            });
        },
        toggleLeftButtonPanel() {
            this.$refs?.['vmsMainGrid']?.togglePanel?.();
        },
        async doAction(ev) {
            if (!ev?.item?.itemAction) return;
            let act = ev.item.itemAction;
            let params = {};
            params.openInSameWindow = true;
            params.psp = this.psp;
            params.isMainGrid = true;
            params.actVal = act;
            params.needResponse = true;
            let tmpActName = 'open' + library.capitalizeFirstLetter(act);
            let tmpActNameEntity = act + 'Entity';
            /* end popup width section */
            if (act.indexOf('HelpMenu') !== -1) {
                await actionStore.openHelpMenu(params);
            } else if (typeof actionStore[act] === 'function') {
                await actionStore[act](params);
            } else if (typeof actionStore[tmpActName] === 'function') {
                await actionStore[tmpActName](params);
            } else if (typeof actionStore[tmpActNameEntity] === 'function') {
                await actionStore[tmpActNameEntity](params);
            } else {
                await actionStore.actions.iframeProcessSubmit(act, params, params.width, params.height);
            }
        },
        async onLoad() {
            this.ddLoading = true;
            await ddStore.preloadGroup('COMMON');
            await ddStore.preloadGroup('DATA_GRID');
            this.ddLoading = false;
            this.ffList = await configStore.getAllClientFFList();
            let addControl = (controlToAdd, disabled) => {
                let tmpControl = {};
                let isDropdownButton = controlToAdd?.items?.length;
                tmpControl.type = isDropdownButton ? 'dropdownbutton' : 'button';
                if (isDropdownButton) {
                    tmpControl.items = controlToAdd.items;
                    tmpControl.fields = { text: 'text', value: 'value' };
                    tmpControl.caretCss = 'fa-regular fa-angle-right';
                }
                tmpControl.label = controlToAdd.text;
                tmpControl.hideLabel = true;
                tmpControl.title = controlToAdd.text;
                tmpControl.name = controlToAdd.value;
                tmpControl.disabled = disabled || false;
                tmpControl.cssClass = 'e-flat nav-new-icon-btn';
                if (!disabled) tmpControl.onclick = 'processTab';
                if (controlToAdd.onclick) tmpControl.onclick = controlToAdd.onclick;
                if (vmsIcons[tmpControl.name]) {
                    tmpControl.icon = {
                        name: vmsIcons[tmpControl.name],
                        size: "2xl"
                    };
                }
                let controlStoreIndex = createStoreIndex(this.storeId, tmpControl.name);
                if (typeof this.controlConfigs === 'undefined') this.controlConfigs = {};
                this.controlConfigs[tmpControl.name] = tmpControl;
                controlStore().addControl(tmpControl, this, controlStoreIndex);
                return tmpControl;
            };
            addControl({
                text: 'Expand',
                value: 'EXPAND',
                onclick: 'toggleLeftButtonPanel'
            });
            let excludeLeftMenu = ['COORD_GLOBAL_FILTERS', 'COORD_PRO'];
            let dashboardId = this.accountSettings['ACCOUNT_EC_DASHBOARD_ID'];
            if (!dashboardId) {
                excludeLeftMenu.push('COORD_DASHBOARD');
            }
            let selectedPspIsFound = false;

            let response = await this.sDs.post('ec_getMainGridInfo', 1, ['menu', 'tabs']);
            if (response && response.status === 'success' && response.data) {
                if (response.data.menu) {
                    let tmpUserMenu = response.data.menu.find((tmp) => tmp.name === 'M_ACCOUNT');
                    if (Array.isArray(tmpUserMenu?.items)) {
                        let tmpItems = [];
                        tmpUserMenu.items.forEach((item) => {
                            tmpItems.push({
                                text: item.title,
                                value: item.name,
                                itemAction: item.action.act
                            });
                        });
                        this.userMenu = library.cloneObj(tmpItems);
                    }
                    let tmpHelpMenu = response.data.menu.find((tmp) => tmp.name === 'M_HELP');
                    // debugger;
                    if (Array.isArray(tmpHelpMenu?.items)) {
                        let tmpItems = [];
                        tmpHelpMenu.items.forEach((item) => {
                            if (item.ITEM_URL.indexOf('/custom/') === -1 && item.ITEM_URL.indexOf('devdash') === -1) {
                                tmpItems.push({
                                    text: item.ITEM_TITLE,
                                    value: item.action,
                                    itemAction: item.action,
                                    itemUrl: item.ITEM_URL
                                });
                            } else {
                                // @todo add to the settings
                            }
                        });
                        this.helpMenu = library.cloneObj(tmpItems);
                    }
                }
                if (response.data.tabs) {
                    for (let i in response.data.tabs) {
                        if (excludeLeftMenu.indexOf(response.data.tabs[i].FF_CONSTANT) === -1) {
                            if (!selectedPspIsFound) {
                                if (this.psp && response.data.tabs[i].FF_CONSTANT === ('COORD_' + this.psp).toUpperCase()) {
                                    selectedPspIsFound = this.psp;
                                }
                                if (!this.psp && response.data.tabs[i].FF_CONSTANT.indexOf('COORD_') !== -1) {
                                    selectedPspIsFound = response.data.tabs[i].FF_CONSTANT.replace('COORD_', '');
                                }
                            }
                            let tmpControl = {
                                value: response.data.tabs[i].FF_CONSTANT,
                                text: response.data.tabs[i].FF_NAME
                            };
                            this.leftMenu.push(addControl(tmpControl));
                        }
                    }
                }
            }
            // @todo add gear and admin options

            if (!this.psp && selectedPspIsFound) {
                this.$router.push({ path: '/' + selectedPspIsFound.toLowerCase() });
            }
            if (
                this.$router?.currentRoute?.value?.query?.action
                && this.$router?.currentRoute?.value?.query?.actionParams
                && typeof actionStore[this.$router?.currentRoute?.value?.query?.action] === 'function'
            ) {
                // @todo move to navigationStore
                if (this.$router?.currentRoute?.value?.query?.actionParams) {
                    actionStore[this.$router?.currentRoute?.value?.query?.action](JSON.parse(this.$router?.currentRoute?.value?.query?.actionParams));
                } else {
                    actionStore[this.$router?.currentRoute?.value?.query?.action]();
                }
            }
        },

    },
    components: {
        menuBar: defineAsyncComponent(() => import('@common/menuBar.vue')),
        'ejs-appbar': defineAsyncComponent(() => import('@common/syncfusion/appBar.vue')),
        'ejs-sidebar': defineAsyncComponent(() => import('@common/syncfusion/sidebar.vue')),
        'ejs-tooltip': defineAsyncComponent(() => import('@common/syncfusion/tooltip')),
        "ejs-dropdownbutton": defineAsyncComponent(() => import('@common/syncfusion/dropdownButton')),
    }
};

componentStore.initComponent(vmsCmp, vmsCfg);
export { vmsCfg, vmsCmp };
export default vmsCmp;
</script>

<style lang="css">
@import "~@common/global.css";
/*@import "~@common/styles/global.css";
@import "~@common/styles/utilities.css";*/
</style>

<style scoped>
:deep(.e-appbar.header) {
    min-height: 3.75rem; /* 60px */
    background-color: var(--color-surface);
    border-bottom: var(--border-default);
    box-shadow: var(--shadow-sm);
    padding: var(--space-1) var(--space-6);
    flex-shrink: 0;
}
:deep(.main-grid-wrapper) {
    display: flex;
    flex-direction: column;
    height: 100vh;
}
:deep(.main-grid-main-content-wrapper) {
    display: flex;
    flex-grow: 12;
}
:deep(.header-image) {
    height: 40px;
    width: auto;
    object-fit: contain;
}
:deep(.panel) {
    padding: 10px;
}
:deep(.panel button) {
    text-align: left;
    text-transform: none;
    font-weight: 500;
    font-size: 13px;
    color: rgb(67, 67, 67);
}
:deep(.panel button .e-btn-icon) {
    font-size: 20px;
    color: rgb(67, 67, 67);
    width: 30px;
    margin-left: 0;
    text-align: center;
    font-weight: 300;
}
:deep(.panel-section) {
    /*margin-bottom: 30px;*/
}

:deep(.panel-section > div) {
    margin-top: 5px;
    margin-bottom: 5px;
}

:deep(.panel-section h4) {
    /*font-size: 1.1em;*/
    margin: 0 0 10px 0;
    color: #959595;
}
:deep(.toggle-panel) {
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 22px;
    font-weight: 300;
    color: #959595;
    position: absolute;
    bottom: 10px;
    margin: 0 auto;
    display: block;
    left: 0;
    right: 0;
}

:deep(.toggle-panel.opened) {
    right: 10px;
    margin: unset;
    left: unset;
}

:deep(hr.panel-separator) {
    border: none;
    height: 1px;
    background-color: #959595;
    margin: 20px 0;
}
:deep(.main-grid-content) {
    flex-grow: 12;
}
:deep(.main-grid-content > div) {
    height: 100%;
}
:deep(.main-grid-content button) {
    text-transform: none;
}
:deep(.nav-new-left) {
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    background-color: #f8f9fa;
}

:deep(.nav-new-expand-btn) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: none;
    background: none;
    color: #6b7280;
    cursor: pointer;
    transition: background-color 0.15s ease,
    color 0.15s ease;
    position: relative;
}

:deep(.nav-new-expand-btn:hover:not(:disabled)) {
    background-color: #e5e7eb;
    color: #111827;
}

:deep(.nav-new-expand-btn:disabled) {
    opacity: 0.4;
    cursor: default;
}

:deep(.nav-new-expand-btn:hover:not(:disabled) .nav-new-expand-tooltip) {
    opacity: 1;
    transform: translateX(0);
}

:deep(.nav-new-icon-btn) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: none;
    background: none;
    color: #495057;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

:deep(.nav-new-icon-btn:hover) {
    background-color: #e9ecef;
    color: #213547;
}

:deep(.nav-new-icon-btn.active) {
    background-color: #213547;
}

:deep(.nav-new-icon-btn.active i) {
    color: var(--color-text-inverse) !important;
}

:deep(.nav-new-icon-btn:hover .nav-new-tooltip) {
    opacity: 1;
    transform: translateX(0);
}
:deep(.nav-new-icons) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
